export default {
  title: 'Do you have an idea for a project?',
  text: 'We\'d love to build something together.',
  socialMedia: [
    { icon: 'linkedin', href: 'https://www.linkedin.com/company/we-app' },
    { icon: 'facebook', href: 'https://www.facebook.com/weappab/' },
    { icon: 'instagram', href: 'https://www.instagram.com/weapp.se/' },
  ],
};
